import { GraphTypes } from '@/components/Common/graph.types';
import { getZoomInRangeLimit } from '@/components/Common/graph.config';
import { Ref } from 'vue';

export function useGraphActions(chartRef: any, graphType: Ref<GraphTypes>) {
  let currentMin: number;
  let currentMax: number;

  const handleZoomIn = () => {
    zoomIn(
      chartRef,
      currentMin,
      currentMax,
      getZoomInRangeLimit(graphType.value),
    );
  };

  const handleZoomOut = () => {
    zoomOut(chartRef, currentMin, currentMax);
  };

  const handleReset = () => {
    reset(chartRef, currentMin, currentMax);
  };

  return {
    handleZoomOut,
    handleReset,
    handleZoomIn,
  };
}

function zoomIn(
  chartRef: { value: { chart: any } },
  currentMin: number,
  currentMax: number,
  MIN_ZOOM_RANGE_LIMIT,
) {
  const childChartRef = chartRef.value?.chart;
  try {
    if (childChartRef?.chart.w.globals.minX)
      currentMin = childChartRef.chart.w.globals.minX;
    if (childChartRef?.chart.w.globals.maxX)
      currentMax = childChartRef.chart.w.globals.maxX;
  } catch (error) {
    // Todo: Handle error
  }
  if (typeof currentMin === 'undefined' && typeof currentMax === 'undefined') {
    reset(chartRef, currentMin, currentMax);
  }
  if (currentMax - currentMin > MIN_ZOOM_RANGE_LIMIT) {
    const centerX = (currentMin + currentMax) / 2;
    let newMinX = (currentMin + centerX) / 2;
    let newMaxX = (currentMax + centerX) / 2;
    const newMinXMaxX = _getNewMinXMaxX(newMinX, newMaxX);
    currentMin = newMinXMaxX.minX;
    currentMax = newMinXMaxX.maxX;
    childChartRef?.zoomX(currentMin, currentMax);
  }
}
function _getNewMinXMaxX(newMinX: number, newMaxX: number) {
  return {
    minX: Math.floor(newMinX),
    maxX: Math.floor(newMaxX),
  };
}
function reset(
  chartRef: { value: any },
  currentMin: number,
  currentMax: number,
) {
  const childChartRef = chartRef.value?.chart;
  currentMax = childChartRef.chart.w.globals.initialMaxX;
  currentMin = childChartRef.chart.w.globals.initialMinX;
  childChartRef.zoomX(currentMin, currentMax);
}
function zoomOut(
  chartRef: { value: any },
  currentMin: number,
  currentMax: number,
) {
  const childChartRef = chartRef.value?.chart;
  try {
    if (childChartRef.chart.w.globals.minX)
      currentMin = childChartRef.chart.w.globals.minX;
    if (childChartRef.chart.w.globals.maxX)
      currentMax = childChartRef.chart.w.globals.maxX;
  } catch (error) {
    // Todo: Handle error
  }

  if (typeof currentMin === 'undefined' && typeof currentMax === 'undefined') {
    reset(chartRef, currentMin, currentMax);
  }
  if (currentMin > 0 && currentMax - currentMin >= 1) {
    const centerX = (currentMin + currentMax) / 2;
    let newMinX = currentMin - (centerX - currentMin);
    let newMaxX = currentMax - (centerX - currentMax);
    const newMinXMaxX = _getNewMinXMaxX(newMinX, newMaxX);
    currentMin = newMinXMaxX.minX;
    currentMax = newMinXMaxX.maxX;
    childChartRef.zoomX(currentMin, currentMax);
  }
}
